// extracted by mini-css-extract-plugin
export default {"list":"Do2j8PUUc98g0zSDhQfn","listItem":"G5z2WEKodwkcqaTMP71Z","listItemTitle":"oUTY15T69hxQaYlPSbFE"};